module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/apple-aa30168b1a8a552f297a55b470d55233.png";